import type { IPersona } from "@next-platform/client-common-core";

import { PERSONA_LIMIT } from "../constants/persona";
import { USER_ROLES } from "../constants/user";

export const isPersonasLimitReached = (personas: IPersona[], role: string, isEdit: boolean, isPartner: boolean) => {
  const totalPersonas = personas?.length;

  if (isPartner) {
    return isEdit ? false : totalPersonas >= PERSONA_LIMIT.PAID_PREMIUM;
  }
  switch (role) {
    case USER_ROLES.MINIMAL:
      return isEdit ? totalPersonas > PERSONA_LIMIT.PAID_MINIMAL : totalPersonas >= PERSONA_LIMIT.PAID_MINIMAL;
    case USER_ROLES.BASIC:
      return isEdit ? totalPersonas > PERSONA_LIMIT.PAID_BASIC : totalPersonas >= PERSONA_LIMIT.PAID_BASIC;
    case USER_ROLES.PREMIUM:
      return isEdit ? totalPersonas > PERSONA_LIMIT.PAID_PREMIUM : totalPersonas >= PERSONA_LIMIT.PAID_PREMIUM;
    default:
      return isEdit ? totalPersonas > PERSONA_LIMIT.FREE : totalPersonas >= PERSONA_LIMIT.FREE;
  }
};
